import scopeExtractor from './scopeExtractor';

/**
 * 
 * @param {String} permission 
 * @return {Boolean}
 */
export default function authorize(permission) {
    let scopes = scopeExtractor(localStorage.getItem("token"));
    return scopes.includes(permission);
}